import styled from 'styled-components';
import {GridTemplate} from '../../shared-components/mixin/GridTemplate.js';
import {Page, PageWrapper} from '../page/Page.js';
import {Aside} from '../page/aside/Aside.js';
import {ModalBody, ModalFooter, ModalHeader} from './ModalFeatures.js';

const HeaderFormChild = `&:has(> ${ModalHeader.toString()} + form ${ModalBody.toString()} + ${ModalFooter.toString()})`;

export const ModalGrid = styled.div`
    overflow: hidden;
    grid-area: modalContent;
    min-height: 250px;

    // === -------- Header and Body and Footer-------- ===
    // === ------------------------------------------- ===
    &:has(
            ${ModalHeader.toString()}:nth-child(1)
                + ${ModalBody.toString()}:nth-child(2)
                + ${ModalFooter.toString()}:nth-child(3)
        ) {
        display: grid;
        ${GridTemplate({
            areas: '"modalHeader" "modalBody" "modalFooter"',
            rows: 'auto 1fr auto',
        })};

        ${ModalBody} {
            overflow-y: auto;
            position: relative;
        }
    }
    // === --------  Body and Footer-------- ===
    // === --------------------------------- ===
    &:has(${ModalBody.toString()} + ${ModalFooter.toString()}) {
        display: grid;
        ${GridTemplate({
            areas: ' "modalBody" "modalFooter"',
            rows: ' 1fr auto',
        })};

        ${ModalBody} {
            overflow-y: auto;
            position: relative;
        }
    }

    // === --- //  Header and Form // --- ===
    ${HeaderFormChild} {
        display: grid;
        ${GridTemplate({
            areas: '"modalHeader" "modalForm"',
            rows: 'auto 1fr',
        })};
        form {
            display: grid;
            grid-area: modalForm;
            overflow: hidden;
            position: relative;
            ${GridTemplate({
                areas: '"modalBody" "modalFooter"',
                rows: '1fr auto',
            })};
        }
    }

    // === -------------------------------------------- ===
    // -------------- For Filter feature -------------- ===
    // === -------- Header and Page and Footer -------- ===
    // === -------------------------------------------- ===
    &:has(
            ${ModalHeader.toString()}:nth-child(1)
                + ${PageWrapper.toString()}:nth-child(2)
                + ${ModalFooter.toString()}:nth-child(3)
        ) {
        display: grid;
        ${GridTemplate({
            areas: '"modalHeader" "modalBody" "modalFooter"',
            rows: 'auto 1fr auto',
        })};
        ${PageWrapper} {
            grid-area: modalBody !important;
        }
    }

    ${Aside.Wrapper} {
        position: absolute;
        bottom: 0px;
        top: 0;
        z-index: 2;
    }
    ${Page.Wrapper} {
        overflow: hidden;
    }
`;
